"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAgreementsByPeriod = exports.is3PAgreement = exports.getAgreementTypeLabel = void 0;
var utils_1 = require("./utils");
var moment_1 = __importDefault(require("@ambler/moment"));
var getAgreementTypeLabel = function (agreementType) {
    switch (agreementType) {
        case 'BILLING':
            return 'Facturation';
        case 'PRICING':
            return 'Tarification';
        case 'RESERVE':
            return 'Réserve';
    }
    (0, utils_1.assertUnreachable)(agreementType);
};
exports.getAgreementTypeLabel = getAgreementTypeLabel;
var is3PAgreement = function (agreementType) { return (0, utils_1.isIn)(['BILLING', 'RESERVE'], agreementType); };
exports.is3PAgreement = is3PAgreement;
var sortAgreementsByPeriod = function (a, b, now) {
    if (now === void 0) { now = (0, moment_1.default)(); }
    // ? Sort active agreements by startDate
    // ? Sort inactive agreements by endDate
    // ? Sort inactive agreements at the bottom of the list
    var isActiveA = now.isBetweenOrIsAfter(a.startDate, a.endDate);
    var isActiveB = now.isBetweenOrIsAfter(b.startDate, b.endDate);
    if (isActiveA && isActiveB) {
        return (0, moment_1.default)(a.startDate).diff((0, moment_1.default)(b.startDate));
    }
    if (!isActiveA && !isActiveB) {
        return (0, moment_1.default)(a.endDate).diff((0, moment_1.default)(b.endDate));
    }
    // * Sort inactive agreements at the bottom of the list
    return !isActiveB ? -1 : 1;
};
exports.sortAgreementsByPeriod = sortAgreementsByPeriod;
//# sourceMappingURL=agreements.js.map